export function setLocalStorageValue(key, value) {
  if (typeof window !== "undefined") {
    // Code that uses localStorage
    localStorage.setItem(key, value)
  }
}

export function getLocalStorageValue(key) {
  if (typeof window !== "undefined") {
    // Code that uses localStorage
    return localStorage.getItem(key)
  }
}
